import React from 'react'
import './playlists.css'
import IMG0 from '../../assets/sortpl.png'
import IMG1 from '../../assets/searchpl.png'
import IMG2 from '../../assets/arrayspl.png'
import IMG3 from '../../assets/bigdatapl.png'
import IMG4 from '../../assets/pythonsmpl.png'
import IMG5 from '../../assets/whiteboxpl.png'

const data = [
  {
    id: 0,
    image: IMG0,
    title: 'Sorting',
    link: 'https://youtube.com/playlist?list=PL9jefoqM2f-P6Ehn7ZtK9OXFZAuWHUiI1'
  },
  {
    id: 1,
    image: IMG1,
    title: 'Searching',
    link: 'https://youtube.com/playlist?list=PL9jefoqM2f-PjhGvQrx3srOa5iIs4gIDY',
    demo: 'https://drive.google.com/file/d/1MPXbbYA5ElY7ZItXGu2Fp63sUkNUeRZ3/view?usp=sharing'
  },
  {
    id: 2,
    image: IMG2,
    title: 'Arrays',
    link: 'https://youtube.com/playlist?list=PL9jefoqM2f-P0BHa_mjkNm-lvvPMqb9cE',
    demo: 'https://drive.google.com/file/d/1hRKMxVSKH73YWooeLRxwe9fSvrtLIveA/view?usp=sharing'
  },
  {
    id: 3,
    image: IMG3,
    title: 'Big Data Analytics',
    link: 'https://youtube.com/playlist?list=PL9jefoqM2f-MUTHq5_1jYm9XOMS3VHTvb',
    demo: 'https://drive.google.com/file/d/1WjcoJnGoQSQ6Wz9ETxQ3O6myWqiV8LIX/view?usp=sharing'
  },
  {
    id: 4,
    image: IMG4,
    title: 'Python Small Projects',
    link: 'https://youtube.com/playlist?list=PL9jefoqM2f-PpdCKjwuWoiDctQcUKeR6S',
    demo: 'https://insurance-prediction-by-yashp.herokuapp.com/'
  },
  {
    id: 5,
    image: IMG5,
    title: 'White Box Testing Numericals',
    link: 'https://youtube.com/playlist?list=PL9jefoqM2f-Mhk8fhrqqIhtXSqFzFMCr7',
    demo: 'https://admission-prediction-by-yashp.herokuapp.com/'
  }
]


const Portfolio = () => {
  return (
    <section id='playlists'>
      <h5>Some of our awesome</h5>
      <h2>Playlists</h2>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, link}) => {
            return (
              <article key={id} className='portfolio__item'>
                <div className="portfolio__item-image">
                  <img src={image} alt={title} />
                </div>
                  <h3 className="tt">{title}</h3>
                  <div className="portfolio__item-cta">
                    <a href={link} className="btn" target='_blank'>Click to Watch!</a>
                  </div>
              </article>
            )
          })
        }        
      </div>
    </section>
  )
}

export default Portfolio